import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PaymentElement,
  useElements,
  useStripe
} from '@stripe/react-stripe-js';
import { message } from 'antd';
import * as Styled from './styles';

type NftCheckoutFormProps = {
  url_key: string | undefined;
  isFullUrl?: boolean;
};

export const NftCheckoutForm = ({
  url_key,
  isFullUrl
}: NftCheckoutFormProps) => {
  const stripe = useStripe();
  const elements = useElements();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!stripe || !elements) {
      /*
       * Stripe.js has not yet loaded.
       * Make sure to disable form submission until Stripe.js has loaded.
       */
      return;
    }

    setIsLoading(true);
    localStorage.setItem('paymentPending', JSON.stringify(true));
    // TODO: if no url_key is present pass current url
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}${
          isFullUrl ? url_key : url_key ? `/nfts/${url_key}` : ''
        }`
      }
    });

    /*
     * This point will only be reached if there is an immediate error when
     * confirming the payment. Otherwise, your customer will be redirected to
     * your `return_url`.
     */
    if (error.type === 'card_error' || error.type === 'validation_error') {
      message.error(error.message);
      localStorage.setItem('paymentPending', JSON.stringify(false));
    } else {
      message.error('An unexpected error occurred.');
      localStorage.setItem('paymentPending', JSON.stringify(false));
    }

    setIsLoading(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <Styled.FormContainer>
        <PaymentElement />
      </Styled.FormContainer>
      <Styled.PaymentButtonWrapper>
        <Styled.Button
          disabled={isLoading || !stripe || !elements}
          htmlType="submit"
          type="primary"
        >
          {t('account.pay')}
        </Styled.Button>
      </Styled.PaymentButtonWrapper>
    </form>
  );
};
